import mange from "./mange"

export default {
	...mange
}
